import { WELCOME_MESSAGE } from './constants';

export function createSessionId() {
  return `session-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function createWelcomeMessage() {
  return {
    role: 'assistant',
    content: WELCOME_MESSAGE,
    timestamp: new Date()
  };
}

export function isErrorLike(content) {
  const lower = String(content || '').toLowerCase();
  return (
    lower.includes('pati një gabim') ||
    lower.includes('nuk mund të lidhem') ||
    lower.includes('më vjen keq, pati') ||
    lower.includes('nuk mund të ngarkohen')
  );
}

export function getMessageMeta(messages, index) {
  const current = messages[index];
  const prev = messages[index - 1];
  const next = messages[index + 1];
  const sameRoleAsPrev = prev && prev.role === current.role;
  const sameRoleAsNext = next && next.role === current.role;

  return {
    showAvatar: current.role === 'assistant' && !sameRoleAsNext,
    showTimestamp: !sameRoleAsNext,
    compactTop: sameRoleAsPrev
  };
}

export function isWelcomeOnly(messages, isLoading) {
  return !isLoading && messages.length === 1 && messages[0].role === 'assistant';
}

export function formatMessageTime(timestamp) {
  return new Date(timestamp).toLocaleTimeString('sq-AL', {
    hour: '2-digit',
    minute: '2-digit'
  });
}
